import React from "react";
import { NavLink,Link } from "react-router-dom";

import chifcologo from "../assets/home/chifcologo.png"
export default ({ close }) => (
  <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    borderTop: "1px solid #eee",
    wordWrap: "break-word",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "1200px"
  }}
>
  <div style={{
    display: "flex",
   
  }}>
    <Link to="/" >
      <img src={chifcologo} style={{ width: 125,  paddingTop: "60px" }} alt="" />
    </Link>
  </div>
  <div
    style={{
      display: "flex",
      height: "100",
   
    }}
  >
      <NavLink to="/" className="itemMenu" exact={true}>À PROPOS</NavLink>
      <NavLink to="/solutions" className="itemMenu" exact={true}>SOLUTIONS</NavLink>
      <NavLink to="/medias" className="itemMenu" exact={true}>MEDIAS</NavLink>
      <NavLink to="/carrieres" className="itemMenu" exact={true}>CARRIÈRES</NavLink>
      <NavLink to="/blog" className="itemMenu" exact={true}>BLOG</NavLink>
      <NavLink to="/contact" className="itemMenu" exact={true}>CONTACT</NavLink>
  </div>
</div>

);


// WEBPACK FOOTER //
// ./src/home/Menu.js